import { clsx } from 'clsx'

import { Image } from '@tribeplatform/gql-client/global-types'
import {
  BannerPlaceholder,
  Image as ImageComponent,
} from '@tribeplatform/react-components/common/components'
import { StaticField } from '@tribeplatform/react-components/Views'

interface Props {
  image: Image
  label: string
  highlighted?: boolean
  aspectRatio?: StaticField['settings']['aspectRatio']
  className?: string
  roundedTopOnly?: boolean
}

export const EventImage = ({
  image,
  label,
  highlighted,
  aspectRatio = 'aspect-video',
  className,
  roundedTopOnly,
}: Props) => {
  const src = image?.url
  const roundedClasses = roundedTopOnly ? 'rounded-t-base' : 'rounded-base'
  return (
    <div
      className={clsx(
        'relative',
        roundedClasses,
        aspectRatio || 'aspect-video',
        highlighted && 'ring-2 ring-offset-0 ring-focused',
        className,
      )}
    >
      {!src ? (
        <div className="absolute inset-0">
          <BannerPlaceholder
            className={clsx(
              roundedClasses,
              'aspect-square flex justify-center items-center w-full',
              highlighted && 'ring-2 ring-offset-0 ring-focused',
            )}
            name={label}
          />
        </div>
      ) : (
        <ImageComponent
          className={clsx(
            roundedClasses,
            'object-cover w-full h-full bg-cover bg-center absolute top-0 start-0 aspect-square flex justify-center items-center',
            highlighted && 'ring-2 ring-offset-0 ring-focused',
          )}
          src={src}
          alt={label}
        />
      )}
    </div>
  )
}
